<script>
import mime from 'mime'
import baseMixin from '@/mixins/baseMixin'
import {
  getIconByMIMEType,
  getFileIconColourByMIMEType,
  getFriendlyFileSize,
} from '@/helpers/file-helpers'
import DownloadedFile from '@/models/file/downloadedFile'

export default {
  name: 'FileListItem',
  mixins: [baseMixin],
  props: {
    file: {
      type: DownloadedFile,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disableDownload: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getMimeType() {
      return this.file?.type || mime.getType(this.file.name)
    },
    compIcon() {
      return getIconByMIMEType(this.getMimeType)
    },
    avatarColor() {
      return getFileIconColourByMIMEType(this.getMimeType)
    },
    compPreviewPanelText() {
      if (!this.readOnly) return this.$i18n.t('files.yetToBeUploadedText')
      return ''
    },
    compFileSize() {
      return getFriendlyFileSize(this.file.size)
    },
  },
  methods: {
    viewSelectedFile() {
      this.$emit('viewFile', this.file.id)
    },
    removeFile() {
      this.$emit('removeFile', this.file.id)
    },
  },
}
</script>

<template>
  <v-list-item
    :data-testid="`file-list-item-${file.id}`"
    :class="[
      'overflow-hidden px-0 file-list-item',
      disableDownload ? 'cursor-default disabled-no-focus' : '',
    ]"
    :ripple="!disableDownload"
    @click="disableDownload ? null : viewSelectedFile()"
  >
    <v-list-item-avatar>
      <v-avatar size="42" :color="avatarColor.background">
        <v-icon size="22" :color="avatarColor.foreground">
          {{ compIcon }}
        </v-icon>
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title :title="file.name" class="text-body-2">
        {{ file.name | truncateText(isMediumOrLower ? 30 : 0) }}
      </v-list-item-title>
      <v-list-item-subtitle class="text-caption">
        {{ compFileSize }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn
        v-if="!readOnly"
        :data-testid="`file-list-item-remove-btn-${file.id}`"
        icon
        color="error"
        @click.stop="removeFile"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<style lang="scss" scoped>
@import '@design';

.file-list-item {
  &.disabled-no-focus {
    // Removes background colour change on focus
    &.v-list-item--link:focus::before,
    &.v-list-item:hover::before {
      opacity: 0;
    }
  }
}
</style>
